import React from 'react'
import PropTypes from 'prop-types'
import * as d3 from 'd3'

import ScatterPlot from './ScatterPlot'

class Data extends React.Component {
  static propTypes = {
    mapWidth: PropTypes.number,
    selectedNetwork: PropTypes.string,
    selectedGenre: PropTypes.string,
    isOpen: PropTypes.bool.isRequired
  }

  constructor (props){
      super(props)
      this.state = {
          status: 'init',
          data: null,
          categories: [],
          customEntities: []
      }
    }

  componentDidMount () {
      this.plotUMap()
  }

  componentDidUpdate (prevProps) {
    if (prevProps.selectedGenre !== this.props.selectedGenre || prevProps.selectedNetwork !== this.props.selectedNetwork) {
      this.plotUMap()
    }
  }

  plotUMap () {
    d3.csv('/data/projections_with_metadata_final.csv')
    .then(data => {
      let x = [],
      y = [],
      s = [],
      c1 = [],
      t = [],
      a = [],
      color1 = [];
      let dataArr1 = {}
      let status = 'loading'
      let categories1 = []
      let customEntities = []
      for (let i = 0; i < data.length; i++) {
        let row = data[i];
        let alignments = Number(row['num_alignments']);
        y.push(row['y']);
        x.push(row['x']);
        a.push(Number(row['num_alignments']))
        if (alignments)
        if (alignments > 300000 && alignments < 1000000) {
          alignments = 300000
        } else if (alignments <= 50000) {
          alignments = 50000
        }
        else if (alignments > 1000000) {
          alignments = 1000000
        }
        s.push(alignments);
        t.push(row['topicId']);
        if (row['networks'] === this.props.selectedNetwork && row['topline_genre'] === this.props.selectedGenre) {
          c1.push(this.props.selectedNetwork + ' ' + this.props.selectedGenre + ' Content')
          color1.push('#DE5F46')
        }
        else if (row['networks'] === this.props.selectedNetwork && row['topline_genre'] !== this.props.selectedGenre) {
          c1.push(row['networks'])
          color1.push('#EDC6CD')
        }
        else if (row['topline_genre'] === this.props.selectedGenre) {
          c1.push(this.props.selectedGenre + ' Content')
          color1.push('#4A89F1')
        }
        else if (row['networks'] !== this.props.selectedNetwork && row['topline_genre'] !== this.props.selectedGenre) {
          c1.push('Other');
          color1.push('#A7A9AC')
        }
        dataArr1 = {
          type: 'scattergl',
          mode: 'markers',
          x: x,
          y: y,
          text: t,
          marker: { size: s, sizeref: 4000, sizemode: 'area', color: color1},
          customdata: a,
          transforms: [{ type: 'groupby', groups: c1 }],
          hovertemplate:
            '<b>%{text}</b><br><br>' +
            'Engagements: %{customdata}' +
            '<extra></extra>'
        }
        status = 'success'
        categories1 = c1
      }
      this.setState({
        data: [dataArr1],
        status: status,
        categories: [...new Set(categories1)],
        customEntities: customEntities
      })
    }).catch(() => this.setState({
      status: 'error'
    }))
  }

  render () {
    const isOpen = this.props.isOpen
    return (
      <div>
        {this.state.status === 'error' && <h3>Error while infering sample</h3>}
        {this.state.status === 'success' &&
          <div>
            <ScatterPlot
              data={this.state.data}
              mapWidth={this.state.width}
              selectedGenre={this.props.selectedGenre}
              isOpen={isOpen}
            />
          </div>
        }
      </div>
      )
  }
}

export default Data